import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Modal,
    message
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import {
    PaperClipOutlined,
    LinkOutlined,
    SendOutlined,
    SearchOutlined,
    ReloadOutlined,
    DownloadOutlined
} from '@ant-design/icons'
import moment from 'moment';
import Remark_edit from "./remark_edit";


const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {},
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, { [name]: dateString })
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, { current: page, pagesize: pagesize })
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        // console.log(subtype)
        // return
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, { current: 1, pagesize: old.pagesize })
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        arr.id = that.props.id
        arr.type = that.props.type ? that.props.type : null
        arr.cate = that.props.cate ? that.props.cate : null
        fetch('/Pay/remark', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (!this.state.newcondition.type) {
                    let newcondition = Object.assign({}, this.state.newcondition, { type: data.type })
                    this.setState({
                        newcondition: newcondition
                    })
                }
                that.setState({
                    list: data.datalist,
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    delSel(id) {
        let that = this
        fetch('/Pay/delRemark', {
            method: "POST", body: JSON.stringify({
                id,
                type: that.props.type ? that.props.type : null,
                cate: that.props.cate ? that.props.cate : null
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    render() {
        const columns = [
            {
                title: '备注内容',
                dataIndex: 'content',
                key: 'content',
            }, {
                title: '附件',
                dataIndex: 'fjlist',
                key: 'fjlist',
                width: 200,
                render: (row, record) => {
                    return (<>
                        <Space direction="vertical">
                            {row.length > 0 ? row.map((item, index) =>
                                <a href={item.url} key={index} target="_blank">{item.name}</a>
                            ) : '无'}
                        </Space>
                    </>)
                },
            }, {
                title: '添加时间',
                dataIndex: 'addtime',
                key: 'addtime',
                width: 120,
            }, {
                title: '添加人',
                dataIndex: 'aidname',
                key: 'aidname',
                width: 100,
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 100,
                render: (row, record) => {
                    return (<>
                        <Space>
                            {/*{store.getState().data.info.id == record.aid ? <>*/}
                            <Remark_edit id={record.id} type={this.props.type} cate={this.props.cate} refresh={this.getdata.bind(this)} />
                            <Popconfirm
                                title="确认删除?"
                                onConfirm={() => this.delSel(record.id)}
                                okText="确认"
                                cancelText="取消"
                            >
                                <a href={'javascript:void(0)'} className={'hongse'}>删除</a>
                            </Popconfirm>
                            {/*</> : null}*/}
                        </Space>
                    </>)
                },
            },
        ]
        const { tableloading, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<div style={{ display: 'flex', flexDirection: 'column', gap: 20, width: '100%' }}>
            <div className={this.props.notitle == 1 ? null : 'view_title'} style={this.props.notitle == 1 ? { color: 'rgba(0, 0, 0, 0.85)', fontSize: 14, fontWeight: 'normal', display: "flex", justifyContent: "space-between" } : null}>
                <span>备注信息</span>
                <Remark_edit pay_id={this.props.id} type={this.props.type} cate={this.props.cate} refresh={this.getdata.bind(this)} />
            </div>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                style={{ width: '100%' }}
            />
            <Row justify={'center'} style={{ width: '100%' }}>
                <Pagination showQuickJumper
                    current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                    pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                    total={this.state.count} onChange={this.pagechange.bind(this)}
                    showTotal={total => `共 ${total} 条数据`} />
            </Row>
        </div>)
    }
}

export default Index
